module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/login/components/login-form/login-form.component.sass
// module id = ./src/app/modules/login/components/login-form/login-form.component.sass
// module chunks = main